<!--
 * @Author: Latte
 * @Date: 2021-10-20 11:08:37
 * @LAstEditors: Latte
 * @LastEditTime: 2021-10-28 11:30:16
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\QuizManagement\ExpertList.vue
-->
<template>
	<div class="app-container">
		<div class="topbar">
			<el-button type="primary" size="small" @click="handleOpenInviteDlg()">邀请</el-button>
		</div>
		<el-table border :data="tableData" :header-cell-style="{ background: '#F5F7FA' }"
			style="width: 100%; margin-bottom: 20px" v-loading="loading">
			<el-table-column align="center" label="#" prop="userId"></el-table-column>
			<el-table-column align="center" label="姓名" prop="nickname"></el-table-column>
			<el-table-column align="center" label="性别" prop="sex">
				<template #default="scope">
					{{scope.row.sex | sexTransform}}
				</template>
			</el-table-column>
			<el-table-column v-if="userDataTypeOption.length > 0" align="center" label="所属领域" prop="userDataType">
				<template #default="scope">
					{{scope.row.userDataType | userDataTypeTransform}}
				</template>
			</el-table-column>
			<el-table-column align="center" label="医院" prop="hospital"></el-table-column>
			<el-table-column align="center" label="科室" prop="medicalLab"></el-table-column>
			<el-table-column align="center" label="头衔" prop="jobTitle"></el-table-column>
			<el-table-column align="center" label="职务" prop="job"></el-table-column>
			<el-table-column align="center" label="擅长" prop="goodAt" show-overflow-tooltip=""></el-table-column>
			<el-table-column align="center" label="简介" prop="resume" show-overflow-tooltip=""></el-table-column>
			<el-table-column align="center" label="等级">
				<template slot-scope="scope">
					{{ scope.row.level | levelTransform }}
				</template>
			</el-table-column>
			<el-table-column align="center" label="创建时间">
				<template slot-scope="scope">
					{{ scope.row.createTime | formatDateTime }}
				</template>
			</el-table-column>
			<el-table-column align="center" label="通知方式">
				<template slot-scope="scope">
					{{scope.row.type | notificationTypeTransform}}
				</template>
			</el-table-column>
			<el-table-column align="center" label="操作">
				<template slot-scope="scope">
					<el-button type="danger" size="small" @click="handleRemove(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination background layout="prev, pager, next" :total="totalCount" :page-size="pageSize"
			:current-page="currentPage" @current-change="currentChange" />

		<!-- 邀请专家对话框 -->
		<el-dialog title="邀请专家回答" width="60%" :visible.sync="inviteDialogVisible" :close-on-click-modal="false">
			<el-form :model="formData" label-position="top" @submit.native.prevent="handleInvite">
				<el-form-item label="邀请指定专家回答" prop="expertInfo">
					<el-input v-model="formData.expertInfo"
						placeholder="userID/手机号MobilePhone/登录名LoginName/登录邮箱LoginEmail"
						@input.native="inputDetectExpertValueChange"></el-input>
					<p v-if="showDetectExpertRes">{{hasExpert ? '存在该专家' : '该专家不存在'}}</p>
					<el-button type="primary" size="small" @click="handleDetect" style="margin-top: 20px">用户检测
					</el-button>
				</el-form-item>
				<el-form-item label="邀请信息发送方式" prop="type">
					<el-select v-model="formData.type">
						<el-option v-for="item in notificationTypeOptions" :key="item" :value="item"
							:label="item | notificationTypeTransform"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" native-type="submit">发送邀请</el-button>
					<el-button size="small" @click="inviteDialogVisible = false">返回</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getExpertList,
		deleteExpert,
		inviteExpert,
		addExpert
	} from "@/api/mai/quizManagement/quizDetail";
	import {
		getProblemConfig
	} from "@/api/mai/quizManagement/quizManagement"
	import {
		deepClone
	} from "@/utils/index"
	import {
		isVaild
	} from "@/utils/validate"
	import {
		getExpertInfo
	} from "@/api/expertManagement";
	import {
		handleRes
	} from "@/utils/handleRes";
	import {
		printObj
	} from "@/utils/debug"
  import {getUserType} from "@/utils/userutil";
	export default {
		props: {
			problemId: Number,
		},
		data() {
			return {
        userDataTypeOption:[],
				totalCount: 0,
				pageSize: 10,
				currentPage: 1,
				tableData: [],
				loading: false,
				inviteDialogVisible: false,
				formData: {
					expertInfo: "",
					type: 0,
				},
				hasExpert: false,
				problemConfig: {},
				notificationTypeOptions: [0, 1, 2],
				showDetectExpertRes: false
			};
		},
		created() {
      this.userDataTypeOption = getUserType()
			this.getProblemConfig()
			this.refreshCurrentList();
		},
		// activated() {
		//   this.refreshCurrentList()
		// },
		methods: {
			inputDetectExpertValueChange(text) {
				console.log('000000 change')
				this.hasExpert = false
				this.showDetectExpertRes = false
			},
			getProblemConfig() {
				getProblemConfig().then(res => {
					handleRes(res, () => {
						this.problemConfig = res.data
					})
				})
			},
			handleOpenInviteDlg() {
				this.formData = {}
				this.inviteDialogVisible = true
				this.hasExpert = false;
			},
			refreshCurrentList() {
				this.getExpertList();
			},
			currentChange(currentPage) {
				this.currentPage = currentPage;
				this.refreshCurrentList();
			},
			getExpertList() {
				this.loading = true;
				const params = {
					problemId: Number(this.problemId),
					pageNumber: this.currentPage,
					pageSize: this.pageSize,
				};
				getExpertList(params).then((res) => {
					this.tableData = res.data.rows
					this.totalCount = res.data.total;
					this.loading = false;
				});
			},
			/**
			 * @description: 删除专家
			 * @param {*} row
			 * @return {*}
			 */
			handleRemove(row) {

				this.$confirm("是否删除该专家", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						deleteExpert({
							problemId: row.problemId,
							userId: row.userId
						}).then((res) => {
							handleRes(res, () => {
								this.refreshCurrentList()
							});
						});
					})

			},
			/**
			 * @description: 检测是否存在用户
			 * @param {*}
			 * @return {*}
			 */
			handleDetect() {
				this.hasExpert = false;
				if (!this.formData.expertInfo) {
					this.$message({
						type: "warning",
						message: "请输入数据",
					});
				} else {
					const params = {
						Account: this.formData.expertInfo,
					};
					getExpertInfo(params).then((res) => {
						handleRes(res, () => {
							this.showDetectExpertRes = true;
							if (isVaild(res.data) && res.data.isAudited === true) {
								this.formData.userId = res.data.createUserId;
								this.formData.mobilePhone = res.data.mobilePhone
								this.hasExpert = true;
							} else {
								this.hasExpert = false;
							}

						})
					});
				}
			},
			handleInvite() {
				if (!this.hasExpert) {
					this.$message({
						type: "warning",
						message: "请通过用户检测后发送邀请",
					});
				} else {
					const params = deepClone(this.formData)
					params.problemId = this.problemId
					// printObj(params)
					addExpert(params).then((res) => {
						handleRes(res, () => {
							this.refreshCurrentList()
						});
					});
					this.inviteDialogVisible = false;
				}
			},
		},
	};
</script>

<style>
</style>
